import { createApp } from 'vue'
import App from './App.vue'

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "font-awesome/css/font-awesome.css"

import { options, language } from "./config.js"
import { createI18n } from "vue-i18n"

const i18n = createI18n({
  warnHtmlInMessage: "off",
  fallbackLocale: language.locale,
  ...language,
});

//import sdk from "@one-commerce/sdk-shop-vue3"
import one from "./plugins/one.js"
import fetising from "./plugins/fetising.js"

window.addEventListener("message", (message) => { 
  if (window.location.origin !== message.origin) {
    console.log("[Sztkm-IFrame]", message.origin, message.data);
  }
});

const app = createApp(App);
app
  .use(one, options)
  .use(fetising, options)
  .use(i18n)
  .mount("#app");